export interface DashboardEventBanner {
  badge: string;
  title: string;
  subtitle: string;
  description: string;
}

export const DASHBOARD_BANNER_ASSETS = {
  welcomeImage: 'assets/img/banner-tmu.png',
  eventImage: 'assets/img/banner-tmu-tsv.png',
};

export const DASHBOARD_EVENT_BANNER: DashboardEventBanner = {
  badge: 'Sự kiện',
  title: 'Chào mừng Tân sinh viên',
  subtitle: 'Năm học 2025 - 2026',
  description: 'Chúc các bạn có một khởi đầu thành công tại Trường Đại học Thương mại.',
};
